import { render } from "./HomeIndex.vue?vue&type=template&id=2b65d979"
import script from "./HomeIndex.vue?vue&type=script&lang=js"
export * from "./HomeIndex.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrei/Desktop/EO LARAVEL/club-shops-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__